import { Image, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { logo } from "../static"; // Importando do seu arquivo de constantes
import "animate.css";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center vh-100 text-center position-relative overflow-hidden animate__animated animate__fadeIn"
      style={{
        backgroundColor: "#2c2219", // Fundo oficial da firma
        color: "#f4f1ea",
      }}
    >
      {/* PADRÃO DE LOGO EM MINIATURA (Marca d'água) */}
      <div 
        className="position-absolute w-100 h-100"
        style={{
          top: 0,
          left: 0,
          backgroundImage: `url(${logo})`,
          backgroundSize: '40px 40px',
          backgroundRepeat: 'repeat',
          opacity: 0.04, 
          zIndex: 1
        }}
      />

      <Container className="position-relative" style={{ zIndex: 2 }}>
        {/* LOGO CENTRAL */}
        <Image
          src={logo}
          alt="Paul Rodney & Associados"
          style={{ width: "120px", marginBottom: "2rem", filter: "brightness(0) invert(1)" }}
          className="animate__animated animate__fadeInDown"
        />

        {/* CÓDIGO DO ERRO */}
        <h1
          className="fw-bold animate__animated animate__fadeInUp"
          style={{ 
            fontSize: "6rem", 
            letterSpacing: "5px", 
            fontFamily: "'Playfair Display', serif",
            color: "#c5a47e" // Dourado da firma
          }}
        >
          404
        </h1>

        {/* MENSAGEM */}
        <h3
          className="text-uppercase fw-light mb-3 animate__animated animate__fadeInUp"
          style={{ letterSpacing: "3px", color: "#f4f1ea" }}
        >
          Página Não Encontrada
        </h3>
        
        <p
          className="opacity-75 mb-5 animate__animated animate__fadeInUp mx-auto"
          style={{ maxWidth: "500px", fontWeight: "300" }}
        >
          O conteúdo jurídico que procura não foi localizado. O endereço pode ter sido alterado 
          ou a página encontra-se temporariamente indisponível.
        </p>

        {/* BOTÃO ELEGANTE */}
        <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center animate__animated animate__fadeInUp">
          <button
            className="btn px-5 py-3 rounded-0 fw-bold border-0"
            style={{
              background: "#c5a47e",
              color: "#fff",
              transition: "all 0.3s ease",
            }}
            onClick={() => navigate("/")}
            onMouseEnter={(e) => (e.target.style.background = "#d6b692")}
            onMouseLeave={(e) => (e.target.style.background = "#c5a47e")}
          >
            Ir para a Página Inicial
          </button>

          <button
            className="btn px-5 py-3 rounded-0 fw-bold btn-outline-light"
            style={{ transition: "all 0.3s ease" }}
            onClick={() => navigate(-1)}
          >
            ← Voltar Atrás
          </button>
        </div>
      </Container>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&display=swap');
        
        .btn-outline-light:hover {
          background-color: #f4f1ea !important;
          color: #2c2219 !important;
        }
      `}</style>
    </div>
  );
};

export default NotFound;